import { render, staticRenderFns } from "./checkbox-group.vue?vue&type=template&id=044f3bee&scoped=true&"
import script from "./checkbox-group.vue?vue&type=script&lang=js&"
export * from "./checkbox-group.vue?vue&type=script&lang=js&"
import style0 from "./checkbox-group.vue?vue&type=style&index=0&id=044f3bee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044f3bee",
  null
  
)

export default component.exports